<div class="alert alert-{{type()}}">
  <div class="alert-content">
    <mat-icon class="alert-icon">{{alertIcon}}</mat-icon>
    <span class="alert-message">
      @if (message()) {
        {{message()}}
      } @else {
        <ng-content></ng-content>
      }
    </span>
  </div>
  @if (dismissible()) {
    <button mat-icon-button class="alert-dismiss" (click)="dismiss()" aria-label="Dismiss">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
